import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import { client } from "./api/client";
import { Navbar } from "./features/navbar/Navbar";
import { Home } from "./features/home/Home";
import { Pages } from "./features/calculators/Pages";
import { Footer } from "./features/footer/Footer";
import { setStatus, changeView } from "./features/calculators/calculatorsSlice";

const theme = createTheme({
	palette: {
		primary: {
			main: "#00558C",
			contrastText: "#FFFFFF"
		},
		secondary: {
			main: "#F5851D",
			contrastText: "#FFFFFF"
		},
		success: {
			main: "#4caf50",
			contrastText: "#FFFFFF"
		}
	},
	typography: {
		fontFamily: [
			"Roboto",
			"sans-serif"
		].join(",")
	},
	components: {
		MuiLink: {
			styleOverrides: {
				root: {
					color: "#E36B25",
					cursor: "pointer"
				}
			}
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					boxShadow: "none",
					backgroundColor: "#F0EDEA"
				}
			}
		},
		MuiTableContainer: {
			styleOverrides: {
				root: {
					border: "0.5px solid rgba(0, 85, 140, .3)",
					boxShadow: "rgba(0, 85, 140, .2) 0px 0px 10px",
					borderRadius: 8
				}
			}
		},
		MuiCard: {
			styleOverrides: {
				root: {
					display: "flex",
					flexDirection: "column",
					border: "0.5px solid rgba(0, 85, 140, .3)",
					boxShadow: "rgba(0, 85, 140, .2) 0px 0px 10px",
					borderRadius: 8
				}
			}
		},
		MuiCardContent: {
			styleOverrides: {
				root: {
					flex: 1,
					display: "flex"
				}
			}
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					paddingTop: 2
				}
			}
		},
		MuiAlert: {
			styleOverrides: {
				root: {
					color: "#FFFFFF"
				}
			}
		}
	}
});

export const App = () => {
	const dispatch = useDispatch();
	const loadingStatus = useSelector(state => state.calculators.status);
	const location = useLocation();

	const check = async () => {
		let data = new FormData();
		data.append("mode", "check");
		const result = await client.post("./api.php", data);
		!result.success && dispatch(setStatus("error"));
	};

	useEffect(() => {
		dispatch(changeView(location.pathname.slice(1)));
		check();
		setInterval(() => {
			check();
		}, 60 * 1000);
	}, []);

	const redirect = () => {
		const url = window.location.origin;
		window.location.assign(`${url}/novusiii/application/login/?redirect=${url}/profitability-calculators`);
	};

	useEffect(() => {
		loadingStatus === "error" && redirect();
	}, [loadingStatus]);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Navbar />
			<main style={{paddingTop: 82}}>
				<Box sx={{minHeight: "calc(100vh - 154px)"}}>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="*" element={<Pages />} />
					</Routes>
				</Box>
				<Footer />
			</main>
		</ThemeProvider>
	);
};
